import { render, staticRenderFns } from "./CourseDataApp.vue?vue&type=template&id=03b32a5e&"
import script from "./CourseDataApp.vue?vue&type=script&lang=js&"
export * from "./CourseDataApp.vue?vue&type=script&lang=js&"
import style0 from "./CourseDataApp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports